export default {
  cardholder_name: 'Fulde navn',
  cardholder_name_placeholder: 'Navn på kort',
  card_number: 'Kortnummer',
  card_number_placeholder: '1234 5678 9012 3456',
  expiry: 'Udløbsdato',
  expiry_placeholder: 'MM / ÅÅ',
  cvv: 'Sikkerhedskode',
  cvv_label: 'Sikkerhedskode (CVC)',
  cvv_placeholder: 'CVC',
  loading: 'Initialiserer sikker kortformular…',
  sdk_load_failed: 'Den sikre kortformular kunne ikke indlæses. Tjek din forbindelse, og genindlæs siden.',
  errors: {
    number_blank: 'Indtast dit kortnummer.',
    number_invalid: 'Dette kortnummer er ikke gyldigt. Tjek cifrene, og prøv igen.',
    number_incomplete: 'Dit kortnummer er ikke komplet.',
    cvv_blank: 'Indtast sikkerhedskoden på bagsiden af dit kort.',
    cvv_invalid: 'Denne sikkerhedskode er ikke gyldig. Tjek de 3 eller 4 cifre på dit kort.',
    cvv_incomplete: 'Indtast alle {{count}} cifre i din sikkerhedskode.',
    expiry_invalid: 'Indtast en gyldig udløbsdato som MM / ÅÅ.',
    expired: 'Dette kort er udløbet. Brug et andet kort.',
    name_blank: 'Indtast navnet præcis, som det står på dit kort.',
    configuration: 'Kortbetalinger er ikke tilgængelige lige nu. Prøv en anden betalingsmetode.',
    generic: 'Vi kunne ikke kontrollere dine kortoplysninger. Prøv igen.',
  },
};
